/** A report gives each view its own route, `/reports/:key/<tab>` (`recordTabRoutes`); the filters stay in the query string. */
export const REPORT_TABS = ['figures', 'records'] as const;
export type ReportTab = (typeof REPORT_TABS)[number];

export const REPORT_TAB_LABELS: Record<ReportTab, string> = { figures: 'Figures', records: 'Records' };

export const REPORTS_PATH = '/reports';

export function reportPath(key: string): string {
  return `${REPORTS_PATH}/${key}`;
}

/** `search` is a query string (with or without the `?`), so a link can carry the filters from one tab to the other. */
export function reportTabPath(key: string, tab: ReportTab, search = ''): string {
  const query = search.replace(/^\?/, '');
  return `${reportPath(key)}/${tab}${query ? `?${query}` : ''}`;
}
